export function readCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`
  const cookie = document.cookie.split("; ").find(entry => entry.startsWith(prefix))
  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : ""
}

export function writeCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 86_400_000).toUTCString()
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
}

export function deleteCookie(name) {
  document.cookie = `${encodeURIComponent(name)}=; max-age=0; path=/; SameSite=Lax`
}
